import axios from "axios";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import Loader from "../../components/Loader";
import Modal from "../../components/Modal/Modal";
import useAuth from "../../hooks/useAuth";
import { BASE_URL } from "../../utils/Element";
import { getPercentAskingPrice } from "../../utils/utils";
import AddOfferData from "./components/AddOfferData";

const initialData = {
  list_type: "",
  type_id: "",
  user_type: "buyer",
  offer_cap_rate: "",
  offer_price: "",
  asking_price: "",
  bds_buyer_id: "",
  bds_seller_id: "",
  br_seller_id: "",
  br_buyer_id: "",
  created_at: "",
  version: "",
  seller_bds: "",
  seller_broker: "",
  buyer_bds: "",
  buyer_broker: "",
  buyer_exclusive_id: "",
  buyer_lead_id: "",
  seller_exclusive_id: "",
  seller_lead_id: "",
  buyer_contact_id: "",
  seller_contact_id: "",
  seller_list_type: "",
  seller: "",
  buyer: { id: "", name: "" },
  property: { id: "", name: "" },
  brokerType: "",
  noi_rent: "",
  broker_seller_type: "",
  br_seller_id: "",
  broker_seller: "",
  broker_buyer_type: "",
  br_buyer_id: "",
  broker_buyer: "",
  asking_cap_rate: "",
  asking_price: "",
};

const EditOfferModal = ({ showModal, onClose, onCallApi, id, leadId }) => {
  const [config] = useAuth();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  const [formData, setFormData] = useState(initialData);

  useEffect(() => {
    if (id && showModal) {
      setLoading(true);
      axios
        .get(`${BASE_URL}/offer-getby-Id/${id}`, config)
        .then((res) => {
          const data = res?.data;

          const listType = data?.buyer_exclusive_id
            ? "exclusive"
            : data?.buyer_lead_id
              ? "leads"
              : data?.buyer_contact_id
                ? "contacts"
                : "";

          const sellerlistType = data?.seller_exclusive_id
            ? "exclusive"
            : data?.seller_lead_id
              ? "leads"
              : data?.seller_contact_id
                ? "contacts"
                : "";

          // 🆕 Normalize multi-broker arrays
          const buyerBrokers = Array.isArray(data?.buyer_detail_name_id)
            ? data.buyer_detail_name_id.map((b) => ({
              id: b.id,
              name: b.name,
              type: b.type,
            }))
            : [];

          const sellerBrokers = Array.isArray(data?.seller_detail_name_id)
            ? data.seller_detail_name_id.map((b) => ({
              id: b.id,
              name: b.name,
              type: b.type,
            }))
            : [];

          setFormData({
            type_id: data?.lead_id,
            offer_price: data?.offer_price,
            offer_cap_rate: data?.offer_cap_rate,
            noi_rent: data?.link?.anual_rent,
            list_type: listType,
            seller_list_type: sellerlistType,

            seller_exclusive_id: data?.seller_exclusive_id,
            seller_lead_id: data?.seller_lead_id,
            seller_contact_id: data?.seller_contact_id,

            buyer_exclusive_id: data?.buyer_exclusive_id,
            buyer_lead_id: data?.buyer_lead_id,
            asking_price: data?.link?.asking_price,
            asking_cap_rate: data?.link?.asking_cap_rate,
            portfolio: data?.portfolio === 1 ? 1 : 0,

            seller: {
              id: data?.disposition_name_id?.id,
              name: data?.disposition_name_id?.name,
            },
            property: {
              id: data?.link?.id,
              name: data?.link?.property_name,
            },
            buyer: {
              id: data?.acquistion_name_id?.id,
              name: data?.acquistion_name_id?.name,
            },

            // 🆕 Multi-broker fields - Seller
            broker_seller_type: sellerBrokers?.[0]?.type || "",
            br_seller_id: sellerBrokers.map((b) => b.id),
            broker_seller: sellerBrokers,

            // 🆕 Multi-broker fields - Buyer
            broker_buyer_type: buyerBrokers?.[0]?.type || "",
            br_buyer_id: buyerBrokers.map((b) => b.id),
            broker_buyer: buyerBrokers,

            buyer_contact_id: data?.buyer_contact_id,
            buyer_options: data?.acquistion_name,
            seller_options: data?.disposition_name,

            bds_seller: data?.seller_bds
              ? `${data.seller_bds.first_name || ""} ${data.seller_bds.last_name || ""}`.trim()
              : "",
            bds_buyer: data?.buyer_bds
              ? `${data.buyer_bds.first_name || ""} ${data.buyer_bds.last_name || ""}`.trim()
              : "",
            created_at: data?.created_at,
            offer_version: data?.version,
            user_type: data?.type,
          });
        })

        .catch((err) => {
          if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
            NotificationManager.error(err.response?.data?.message);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [id, showModal]);

  const handleClose = () => {
    setFormData(initialData);
    onClose();
    setError();
    setDisable(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisable(true);

    const percent_of_asking_price = getPercentAskingPrice(
      formData?.offer_price,
      formData?.offer_cap_rate
    );

    const dataToSend = {
      offer_price: formData?.offer_price,
      offer_cap_rate: formData?.offer_cap_rate,
      type: formData?.user_type,
      percent_of_asking_price,
      noi_rent: formData?.noi_rent,
      // Broker IDs for submission
      broker_seller: formData?.br_seller_id,
      bds_seller: formData?.bds_seller_id,
      broker_buyer: formData?.br_buyer_id,
      bds_buyer: formData?.bds_buyer_id,

      created_at: formData?.created_at,
      offer_version: formData?.offer_version,

      buyer_exclusive_id: formData?.buyer_exclusive_id,
      buyer_lead_id: formData?.buyer_lead_id,
      buyer_contact_id: formData?.buyer_contact_id,
      seller_exclusive_id: formData?.seller_exclusive_id,
      seller_lead_id: formData?.seller_lead_id,
      seller_contact_id: formData?.seller_contact_id,
      asking_price: formData?.asking_price,
      asking_cap_rate: formData?.asking_cap_rate,

      seller: formData?.seller,
      buyer: formData?.buyer,
      property: formData?.property,
      portfolio: formData?.portfolio === 1 ? 1 : 0,
      ...(formData.broker_seller_type === "inside" && { broker_inside_seller: formData.seller_exclusive_id }),
      ...(formData.broker_seller_type === "outside" && { broker_outside_seller: formData.seller_lead_id }),
      ...(formData.broker_buyer_type === "inside" && { broker_inside_buyer: formData.buyer_exclusive_id }),
      ...(formData.broker_buyer_type === "outside" && { broker_outside_buyer: formData.buyer_lead_id }),
    };

    axios
      .post(`${BASE_URL}/update-offer/${id}`, dataToSend, config)
      .then(() => {
        handleClose();
        onCallApi();
      })
      .catch((err) => {
        setDisable(false);
        setError(err.response?.data?.errors);
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  return (
    <Modal
      width="620px"
      title={`Edit Offer`}
      desc={`Edit the offer information.`}
      show={showModal}
      onClose={handleClose}
    >
      {loading ? (
        <Loader />
      ) : (
        <AddOfferData
          formData={formData}
          error={error}
          onSetFormData={(value) => setFormData(value)}
          onSetError={(value) => setError(value)}
          handleSubmit={handleSubmit}
          handleClose={handleClose}
          showModal={showModal}
          disable={disable}
        />
      )}
    </Modal>
  );
};

export default EditOfferModal;
